export const ISSUES_DOMAIN = "autodesk-bim360-issue";
export const ISSUES_ENTITY_TYPE = "issue";
